import { createFileRoute } from "@tanstack/react-router";

import { WhatsAppTemplatesPage } from "@/pages/Admin";

export const Route = createFileRoute("/app/admin/whatsapp-templates")({
  component: WhatsAppTemplatesPage,
});
